import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import _, { isEmpty } from "lodash";
import { Formik } from "formik";
import { TextField } from "@material-ui/core";
import { Checkbox } from "primereact/checkbox";
import store from "../../../../../store/store";
import {
  getStocksToCount,
  saveStockCounting,
} from "../../../../../services/inventory/itemsMovement";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { Editor } from "primereact/editor";
import { CustomArraySelectField } from "../../../../../partials/content/Forms";
import {
  FormDateField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { getUser } from "../../../../../services/usersService";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DialogActions } from "@material-ui/core";
import { Card } from "react-bootstrap";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../../partials/content/Illustration";
const stockCountingSchema = yup.object().shape({
  ID: yup.number(),
  stockCountingItem: yup.array().of(
    yup.object().shape({
      countedQty: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .min(0, "Counted Quantity must be greater than zero")
        .default(0),
    })
  ),
});
function StocksCountingForm({
  warehouseID = 0,
  outletID = 0,
  onCloseDialog,
  onConfirmSave,
}) {
  const { reload } = useGlobalData();
  const [activeIndex, setActiveIndex] = useState(0);
  const [stockCounting, setStockCounting] = useState({
    ID: 0,
    countDate: DateTime.now(),
    countStatus: 1,
    countStatusDesc: "",
    warehouseID,
    outletID,
    note: "",
    userName: "",
    stockCountingItemRow: {},
    stockCountingItem: [],
  });
  const [consumedStocks, setConsumedStocks] = useState([]);
  useEffect(() => {
    getStockToCountData(warehouseID, outletID, stockCounting.countDate);
  }, [warehouseID, outletID, reload]);

  async function getStockToCountData(
    warehouseID = 0,
    outletID = 0,
    countDate = DateTime.now()
  ) {
    const response = await getStocksToCount(warehouseID, outletID, countDate);
    const { auth } = store.getState();
    const userID = auth.user.userID;
    const { data } = response.data;
    const { warehouseStocks, outletStocks } = data;
    let stocks = [];
    const stockCountingTmp = { ...stockCounting };
    if (warehouseID > 0) {
      stocks = [...warehouseStocks];
    } else if (outletID > 0) {
      stocks = [...outletStocks];
    }
    for (const stock of stocks) {
      stockCountingTmp.stockCountingItem.push({
        counted: false,
        itemID: stock.itemID,
        itemType: stock.itemType,
        itemTypeName: stock.itemTypeName,
        itemCode: stock.itemCode,
        itemName: stock.itemName,
        varCode: stock.varCode,
        systemQty: stock.qty,
        countedQty: 0,
        diffQty: 0,
        batchID: stock.batchID,
        moveReasonID: 1,
        uomID: stock.uomID,
        uomName: stock.uomName,
      });
    }
    if (userID) {
      const response = await getUser(userID);
      const { data } = response.data;
      const { user } = data;
      stockCountingTmp.userName = user.firstName + " " + user.lastName;
    }
    setStockCounting(stockCountingTmp);
    setConsumedStocks(data.consumedStocks);
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={stockCounting}
      validationSchema={stockCountingSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        for (const countItem of values.stockCountingItem) {
          countItem.systemQty = parseFloat(countItem.systemQty);
          countItem.countedQty = parseFloat(countItem.countedQty);
          countItem.diffQty = parseFloat(countItem.diffQty);
        }
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Stock Opname ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveStockCounting(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave(values);
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
        >
          <div className="tabview mb-3">
            <div className="card">
              <TabView renderActiveOnly={false} className="tabview" scrollable>
                <TabPanel
                  header="Stock Opname Main"
                  rightIcon="fas fa-th-large"
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-window-maximize"></i>
                          <span>
                            <strong>Stock Opname Header</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Person Responsible"
                                name="userName"
                                readonly
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormDateField
                                label="Stock Opname Date"
                                name="countDate"
                                readonly={
                                  values.stockCountingItem.length > 0
                                    ? false
                                    : true
                                }
                              />
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </TabPanel>
                {values.stockCountingItem.length > 0 ? (
                  <TabPanel header={`Note`} rightIcon="fas fa-sticky-note">
                    <Editor
                      style={{ height: "200px", width: "100%" }}
                      onTextChange={(e) => {
                        setFieldValue("note", e.htmlValue);
                      }}
                      value={values.note}
                      placeholder="Type your notes here..."
                    />
                  </TabPanel>
                ) : (
                  <TabPanel
                    header={`Note`}
                    rightIcon="fas fa-sticky-note"
                    disabled
                  ></TabPanel>
                )}
              </TabView>
            </div>
          </div>
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                {outletID > 0 ? (
                  <AccordionTab
                    header={
                      <React.Fragment>
                        <i className="fas fa-sitemap"></i>
                        <span>
                          <strong>Est Stock Consumed</strong>
                        </span>
                      </React.Fragment>
                    }
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        {consumedStocks.length > 0 ? (
                          <React.Fragment>
                            <CustomDataTable
                              data={consumedStocks}
                              onRefreshData={() => {
                                getStockToCountData(
                                  warehouseID,
                                  outletID,
                                  0,
                                  0
                                );
                              }}
                              columns={[
                                {
                                  header: "Item Type",
                                  field: "itemRecipeTypeName",
                                  body: (rowData) => (
                                    <React.Fragment>
                                      <ResponsiveEllipsis
                                        text={rowData.itemRecipeTypeName}
                                        maxLine="1"
                                      />
                                    </React.Fragment>
                                  ),
                                  sortable: false,
                                  filter: false,
                                  hidden: true,
                                },
                                {
                                  header: "Item Code",
                                  field: "itemRecipeCode",
                                  body: (rowData) => (
                                    <React.Fragment>
                                      {rowData.itemRecipeType > 0 ? (
                                        <span>
                                          <BootstrapTooltip
                                            title={rowData.itemRecipeTypeName}
                                          >
                                            <span className="mr-2">
                                              <i
                                                className={
                                                  rowData.itemRecipeType === 1
                                                    ? "fas fa-boxes text-success"
                                                    : rowData.itemRecipeType ===
                                                      2
                                                    ? "fas fa-tools text-primary"
                                                    : rowData.itemRecipeType ===
                                                      3
                                                    ? "fas fa-building text-info"
                                                    : rowData.itemRecipeType ===
                                                      4
                                                    ? "fas fa-boxes text-warning"
                                                    : rowData.itemRecipeType ===
                                                      5
                                                    ? "fas fa-boxes text-danger"
                                                    : null
                                                }
                                              ></i>
                                            </span>
                                          </BootstrapTooltip>
                                          <span>
                                            <ResponsiveEllipsis
                                              text={rowData.itemRecipeCode}
                                              maxLine="1"
                                              displayInline
                                            />
                                          </span>
                                        </span>
                                      ) : (
                                        <React.Fragment>
                                          <ResponsiveEllipsis
                                            text={rowData.itemRecipeCode}
                                            maxLine="1"
                                          />
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  ),
                                  sortable: false,
                                  filter: false,
                                },
                                {
                                  header: "Item Name",
                                  field: "itemRecipeName",
                                  body: (rowData) => (
                                    <React.Fragment>
                                      <ResponsiveEllipsis
                                        text={rowData.itemRecipeName}
                                        maxLine="1"
                                      />
                                    </React.Fragment>
                                  ),
                                  sortable: false,
                                  filter: false,
                                },
                                {
                                  header: "Qty",
                                  field: "qty",
                                  body: null,
                                  sortable: false,
                                  filter: false,
                                },
                                {
                                  header: "Unit",
                                  field: "uomName",
                                  body: null,
                                  sortable: false,
                                  filter: false,
                                },
                              ]}
                            />
                          </React.Fragment>
                        ) : (
                          <Illustration
                            imageSource="INVIFO Inventory.png"
                            guidance="You don't have any Stock Consumed recored yet"
                            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                            size="sm"
                          ></Illustration>
                        )}
                      </div>
                    </div>
                  </AccordionTab>
                ) : null}
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Stock Opname Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      {values.stockCountingItem.length > 0 ? (
                        <React.Fragment>
                          <CustomDataTable
                            data={values.stockCountingItem}
                            onRefreshData={() => {
                              getStockToCountData(warehouseID, outletID, 0, 0);
                            }}
                            columns={[
                              {
                                header: "Item Type",
                                field: "itemTypeName",
                                body: (rowData) => (
                                  <React.Fragment>
                                    <ResponsiveEllipsis
                                      text={rowData.itemTypeName}
                                      maxLine="1"
                                    />
                                  </React.Fragment>
                                ),
                                sortable: false,
                                filter: false,
                                hidden: true,
                              },
                              {
                                header: "Item Code",
                                field: "itemCode",
                                body: (rowData) => (
                                  <React.Fragment>
                                    {rowData.itemType > 0 ? (
                                      <span>
                                        <BootstrapTooltip
                                          title={rowData.itemTypeName}
                                        >
                                          <span className="mr-2">
                                            <i
                                              className={
                                                rowData.itemType === 1
                                                  ? "fas fa-boxes text-success"
                                                  : rowData.itemType === 2
                                                  ? "fas fa-tools text-primary"
                                                  : rowData.itemType === 3
                                                  ? "fas fa-building text-info"
                                                  : rowData.itemType === 4
                                                  ? "fas fa-boxes text-warning"
                                                  : rowData.itemType === 5
                                                  ? "fas fa-boxes text-danger"
                                                  : null
                                              }
                                            ></i>
                                          </span>
                                        </BootstrapTooltip>
                                        <span>
                                          <ResponsiveEllipsis
                                            text={rowData.itemCode}
                                            maxLine="1"
                                            displayInline
                                          />
                                        </span>
                                      </span>
                                    ) : (
                                      <React.Fragment>
                                        <ResponsiveEllipsis
                                          text={rowData.itemCode}
                                          maxLine="1"
                                        />
                                      </React.Fragment>
                                    )}
                                  </React.Fragment>
                                ),
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Item Name",
                                field: "itemName",
                                body: (rowData) => (
                                  <React.Fragment>
                                    <ResponsiveEllipsis
                                      text={rowData.itemName}
                                      maxLine="1"
                                    />
                                  </React.Fragment>
                                ),
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Counted",
                                field: "counted",
                                body: (rowData, option) => (
                                  <Checkbox
                                    id={`counted[${option.rowIndex}]`}
                                    icon="pi pi-check-circle"
                                    onChange={(e) => {
                                      const itemsTmp = [
                                        ...values.stockCountingItem,
                                      ];
                                      const index = _.findIndex(
                                        itemsTmp,
                                        (item) => {
                                          return (
                                            item.batchID === rowData.batchID
                                          );
                                        }
                                      );
                                      itemsTmp[index].counted = e.checked;
                                      itemsTmp[index].countedQty = 0;
                                      if (itemsTmp[index].counted) {
                                        itemsTmp[index].diffQty =
                                          itemsTmp[index].countedQty -
                                          itemsTmp[index].systemQty;
                                      } else {
                                        itemsTmp[index].diffQty = 0;
                                      }
                                      setFieldValue(itemsTmp);
                                    }}
                                    checked={rowData.counted}
                                  />
                                ),
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "System Quantity",
                                field: "systemQty",
                                body: null,
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Counted Quantity",
                                field: "countedQty",
                                body: (rowData, option) => (
                                  <React.Fragment>
                                    {rowData.counted ? (
                                      <TextField
                                        id={`countedQty[${option.rowIndex}]`}
                                        type="number"
                                        fullWidth
                                        value={rowData.countedQty}
                                        variant="outlined"
                                        size="small"
                                        onChange={(e) => {
                                          if (isEmpty(e.target.value)) {
                                            e.target.value = 0;
                                          }
                                          e.target.value = parseFloat(
                                            e.target.value
                                          );
                                          const countedQty = parseFloat(
                                            e.target.value
                                          );
                                          const itemsTmp = [
                                            ...values.stockCountingItem,
                                          ];
                                          const index = _.findIndex(
                                            itemsTmp,
                                            (item) => {
                                              return (
                                                item.batchID === rowData.batchID
                                              );
                                            }
                                          );
                                          itemsTmp[
                                            index
                                          ].countedQty = countedQty;
                                          if (itemsTmp[index].systemQty > 0) {
                                            itemsTmp[index].diffQty =
                                              countedQty -
                                              itemsTmp[index].systemQty;
                                          } else {
                                            itemsTmp[
                                              index
                                            ].diffQty = countedQty;
                                          }
                                          if (
                                            itemsTmp[index].diffQty > 0 &&
                                            itemsTmp[index].moveReasonID > 2
                                          ) {
                                            itemsTmp[index].moveReasonID = 1;
                                          }
                                          setFieldValue(itemsTmp);
                                        }}
                                      />
                                    ) : null}
                                  </React.Fragment>
                                ),
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Different Quantity",
                                field: "diffQty",
                                body: (rowData) => (
                                  <>
                                    {rowData.diffQty > 0 ? (
                                      <span className="text-success">{`+${rowData.diffQty}`}</span>
                                    ) : rowData.diffQty < 0 ? (
                                      <span className="text-danger">{`${rowData.diffQty}`}</span>
                                    ) : (
                                      rowData.diffQty
                                    )}
                                  </>
                                ),
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Different Reason",
                                field: null,
                                body: (rowData, option) => {
                                  const index = _.findIndex(
                                    values.stockCountingItem,
                                    (item) => {
                                      return item.batchID === rowData.batchID;
                                    }
                                  );
                                  return (
                                    <React.Fragment>
                                      {rowData.diffQty !== 0 &&
                                      rowData.counted ? (
                                        <CustomArraySelectField
                                          arrayName="stockCountingItem"
                                          propertyName="moveReasonID"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          index={index}
                                          value={values}
                                          touched={touched}
                                          errors={errors}
                                          options={
                                            rowData.diffQty > 0
                                              ? [
                                                  {
                                                    label: "Stock Adjustment",
                                                    value: 1,
                                                  },
                                                  {
                                                    label: "Production",
                                                    value: 2,
                                                  },
                                                ]
                                              : rowData.diffQty < 0
                                              ? [
                                                  {
                                                    label: "Stock Lost",
                                                    value: 1,
                                                  },
                                                  {
                                                    label: "Stock Damaged",
                                                    value: 2,
                                                  },
                                                  {
                                                    label: "Stock Expired",
                                                    value: 3,
                                                  },
                                                  {
                                                    label: "Stock Sold",
                                                    value: 4,
                                                  },
                                                ]
                                              : []
                                          }
                                          size="small"
                                        />
                                      ) : null}
                                    </React.Fragment>
                                  );
                                },
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Unit",
                                field: "uomName",
                                body: null,
                                sortable: false,
                                filter: false,
                              },
                              {
                                header: "Batch ID",
                                field: "batchID",
                                body: null,
                                sortable: false,
                                filter: false,
                              },
                            ]}
                          />
                        </React.Fragment>
                      ) : (
                        <Illustration
                          imageSource="INVIFO Inventory.png"
                          guidance="You don't have any Stock which needs to be counted in this warehouse yet"
                          guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                          size="sm"
                        ></Illustration>
                      )}
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            {values.stockCountingItem.length > 0 ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>
        </form>
      )}
    </Formik>
  );
}

export default StocksCountingForm;
